import { brandState, getClientBrand, loadClientBrand, normalizeBrandKey } from "../branding/brandingService";
import { deriveTheme } from "../branding/themeAdapter";

let vuetifyRef = null;

export function initClientTheme(store, vuetify) {
  vuetifyRef = vuetify;
  store.watch(
    (state) => state.userType,
    (userType) => applyClientTheme(userType),
    { immediate: true }
  );
}

export function resetClientTheme() {
  applyClientTheme(null);
}

let activeBrandKey = null;

export function applyClientTheme(source) {
  const requestedBrandKey = normalizeBrandKey(source);
  activeBrandKey = requestedBrandKey;

  applyBrand(getClientBrand(source));

  if (requestedBrandKey) {
    loadClientBrand(source)
      .then((mergedBrand) => {
        if (activeBrandKey === requestedBrandKey) {
          applyBrand(mergedBrand);
        }
      })
      .catch(() => {});
  }
}

function applyBrand(brand) {
  if (brand.key === "DEFAULT") {
    document.documentElement.removeAttribute("data-client");
  } else {
    document.documentElement.setAttribute("data-client", brand.key);
  }
  const { vuetify, cssVars } = deriveTheme(brand.colors);
  setVuetifyColors(vuetify);
  setCssTokens(cssVars);
  setFavicon(brand.favicon);
  document.title = brand.productName;
  brandState.brand = brand;
}

function setVuetifyColors(palette) {
  if (vuetifyRef?.framework?.theme) {
    Object.assign(vuetifyRef.framework.theme.themes.light, palette);
  }
}

function setFavicon(href) {
  if (!href) return;
  let link = document.querySelector("link[rel*='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}

let appliedTokens = [];
function setCssTokens(tokens) {
  const rootStyle = document.documentElement.style;
  appliedTokens.forEach((token) => rootStyle.removeProperty(token));
  appliedTokens = [];
  if (!tokens) return;
  Object.entries(tokens).forEach(([token, value]) => {
    rootStyle.setProperty(token, value);
    appliedTokens.push(token);
  });
}
